import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import { Box } from '@mui/material'
import { ProductSettingsTable } from 'Features/Projects/Scenarios/EditSettings/LineSettings/ProductSettings/ProductSettings.Table'
import { useProductSettings } from '../LineSettings.data'
import { Loader } from 'Common/Loader/Loader'
import { useParams } from 'react-router-dom'
import { EditSettingsDataFilter } from '../../EditSettings.DataFilter'
import { useSettingsContext } from '../../EditSettings.types'
import { useMemo } from 'react'

export const ProductSettingsView = () => {
  const { projectId, scenarioId } = useParams() as {
    projectId: string
    scenarioId: string
  }
  const { state } = useSettingsContext()
  const { selectedBaseSourceSite, selectedWorkCentre } = state

  const { data: productSettings, isLoading } = useProductSettings({
    projectId,
    scenarioId,
  })

  const filteredProductSettings = useMemo(() => {
    if (!productSettings) return []

    let filtered = productSettings

    // Filter by baseSourceSite
    if (selectedBaseSourceSite && selectedBaseSourceSite !== 'All') {
      filtered = filtered.filter(
        (item) => item.baseSourceSiteCode === selectedBaseSourceSite
      )
    }

    // Filter by workCentre
    if (selectedWorkCentre && selectedWorkCentre !== 'All') {
      filtered = filtered.filter(
        (item) => item.workcentreCode === selectedWorkCentre
      )
    }

    return filtered
  }, [productSettings, selectedBaseSourceSite, selectedWorkCentre])

  return (
    <SettingsPage title="SKU production" actions={<EditSettingsDataFilter />}>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        {isLoading ? (
          <Loader />
        ) : (
          <ProductSettingsTable
            data={filteredProductSettings}
            isLoading={isLoading}
          />
        )}
      </Box>
    </SettingsPage>
  )
}
